import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import customPagesApi from "../admincomponents/CustomPagesApi";

export default function LegacyCustomPages() {
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("All");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = () => {
    setLoading(true);
    customPagesApi.list().then(setPages).catch(() => setError("Couldn't load custom pages.")).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (page) => {
    if (!window.confirm(`Delete ${page.title}?`)) return;
    try {
      await customPagesApi.remove(page._id);
      setPages((current) => current.filter((item) => item._id !== page._id));
    } catch {
      setError("Couldn't delete this custom page.");
    }
  };

  const filtered = pages.filter((page) =>
    (status === "All" || page.status === status) &&
    `${page.title} ${page.slug}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-gray-800 font-semibold text-2xl">Custom Pages</h1>
          <p className="text-gray-500 text-sm mt-1">Create and manage flexible custom pages.</p>
        </div>
        <button onClick={() => navigate("/admin/custom-page-builder")} className="bg-teal-600 hover:bg-teal-700 text-white text-sm font-medium px-4 py-2.5 rounded-md">
          Create new page
        </button>
      </div>
      <div className="flex gap-4 mb-6">
        <input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Search by title or slug..." className="flex-1 max-w-md bg-white border border-gray-300 rounded-md px-4 py-2.5 text-sm" />
        <select value={status} onChange={(event) => setStatus(event.target.value)} className="bg-white border border-gray-300 rounded-md px-4 py-2.5 text-sm">
          <option>All</option><option>Draft</option><option>Published</option>
        </select>
      </div>
      {error && <div className="mb-4 bg-red-50 border border-red-100 text-red-600 text-sm rounded-md px-4 py-3">{error}</div>}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-gray-200 bg-gray-50 text-left">
            <th className="px-6 py-4 text-gray-500 font-medium">Title</th>
            <th className="px-6 py-4 text-gray-500 font-medium">Slug</th>
            <th className="px-6 py-4 text-gray-500 font-medium">Status</th>
            <th className="px-6 py-4 text-gray-500 font-medium text-right">Actions</th>
          </tr></thead>
          <tbody>
            {loading && <tr><td colSpan={4} className="px-6 py-10 text-center text-gray-400">Loading custom pages...</td></tr>}
            {!loading && filtered.map((page) => (
              <tr key={page._id} className="border-b border-gray-100 last:border-0">
                <td className="px-6 py-4 font-medium text-gray-800">{page.title}</td>
                <td className="px-6 py-4 text-gray-500">/{page.slug}</td>
                <td className="px-6 py-4 text-gray-600">{page.status}</td>
                <td className="px-6 py-4 text-right space-x-4">
                  <button onClick={() => navigate(`/admin/custom-page-builder/${page._id}`)} className="text-teal-600 font-medium">Edit</button>
                  <button onClick={() => remove(page)} className="text-red-500 font-medium">Delete</button>
                </td>
              </tr>
            ))}
            {!loading && filtered.length === 0 && <tr><td colSpan={4} className="px-6 py-10 text-center text-gray-400">No custom pages found.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}